

export const UPDATE_EMAIL_FREQUENCY = "frequency/UPDATE_EMAIL_FREQUENCY";
export const UPDATE_EMAIL_FREQUENCY_COMPLETED = "frequency/UPDATE_EMAIL_FREQUENCY_COMPLETED";
export const UPDATE_EMAIL_FREQUENCY_FAILED = "frequency/UPDATE_EMAIL_FREQUENCY_FAILED";

